import FlowFieldBackground from './FlowFieldBackground';
import CTASection, { DEFAULT_CTA } from './CTASection';
import Footer from '../Footer';

/** One surface for the CTA band + footer — shared flow lines, no seam. */
export default function CtaFooterBridge({ cta = DEFAULT_CTA }) {
  return (
    <div className="cta-footer-bridge">
      <FlowFieldBackground
        gradientId="cta-footer-flow-grad"
        preset="hero"
        fadeIn={false}
        uniformStroke
      />
      <div className="relative z-[2]">
        <CTASection embedded {...cta} />
        <Footer embedded />
      </div>
    </div>
  );
}
